module.exports = __webpack_public_path__ + "assets/img/three-bg.670a0feb.png";